export default __webpack_public_path__ + "static/media/Icon=Locate.16ae49e0.svg";